import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const auditLogApi = createApi({
  reducerPath: "auditLogs",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["AuditLogs"],
  endpoints: (builder) => ({
    listAuditLogs: builder.query({
      query: ({ token, type, category, action, userEmail, resourceType, clinicId, startDate, endDate, page, limit, success }) => {
        return apiFunction(
          { token, type, category, action, userEmail, resourceType, clinicId, startDate, endDate, page, limit, success },
          "/api/admin/audit-logs/list",
          "POST"
        );
      },
      providesTags: ["AuditLogs"],
    }),
    getAuditLogStats: builder.query({
      query: ({ token, startDate, endDate }) => {
        return apiFunction(
          { token, startDate, endDate },
          "/api/admin/audit-logs/statistics",
          "POST"
        );
      },
      providesTags: ["AuditLogs"],
    }),
  }),
});

export const {
  useListAuditLogsQuery,
  useLazyListAuditLogsQuery,
  useGetAuditLogStatsQuery,
  useLazyGetAuditLogStatsQuery,
} = auditLogApi;
